var _rect, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.6855,
    width: 13.8146,
    height: 13.8146,
    rx: 1.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8166 10.019L16.42 10.2173C16.0812 10.3867 15.8672 10.7329 15.8672 11.1117V23.691C15.8672 24.2433 16.3149 24.691 16.8672 24.691H26.0522H30.0645C31.0521 24.691 31.299 23.4564 31.299 22.8392V20.3701C31.4019 17.4894 31.4225 11.4813 30.6818 10.4937C29.941 9.50603 29.1386 9.25912 28.83 9.25912H23.9038C23.2641 9.25912 22.7909 8.66634 22.8821 8.03313C23.1862 5.92218 22.9658 4.43822 22.9658 3.39501C22.9658 2.46423 21.9607 0.455239 21.2422 0.0547717C21.161 0.00953662 21.0674 -0.000198029 20.9745 0.00273571C20.6427 0.0132189 19.8156 0.0638737 19.5708 0.308637C19.3086 0.570864 19.492 3.95221 19.553 4.96321C19.5643 5.14959 19.5243 5.33415 19.4364 5.4989L17.2518 9.59511C17.1542 9.7781 17.0021 9.92621 16.8166 10.019Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6408,
    cy: 13.8893,
    r: 0.734549,
    fill: "white",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4b91f13468cac7fe56186d4ecde9e856.svg";
export { ForwardRef as ReactComponent };